import React, { useEffect, useState } from 'react';
import './Qr.css';
import { apiUrl } from '../config';

const HERO_SRC = `${process.env.PUBLIC_URL}/assets/gameinyang_logo2.png`;

/**
 * Operator-facing QR display — shown on a screen at the venue (route: /qr).
 * Polls /api/activeSession so the QR refreshes automatically when a new
 * session starts. The QR encodes the backend's `qrUrl`
 * (`<PUBLIC_BASE_URL>/?session=<uuid>`); visitors scan it to join.
 */
export default function Qr() {
  const [session, setSession] = useState(null); // { qrImageUrl, qrUrl } | null
  const [heroFailed, setHeroFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const res = await fetch(apiUrl('/api/activeSession'), { cache: 'no-store' });
        const json = await res.json();
        if (cancelled) return;

        const status = (json?.status || '').toString().toUpperCase();
        if (json?.sessionUuid && status !== 'ENDED' && json?.qrImageUrl) {
          setSession({ qrImageUrl: json.qrImageUrl, qrUrl: json.qrUrl });
        } else {
          setSession(null);
        }
      } catch {
        if (!cancelled) setSession(null);
      }
    };

    load();
    const t = setInterval(load, 5000);
    return () => { cancelled = true; clearInterval(t); };
  }, []);

  return (
    <div className="qr-screen">
      <div className="qr-inner">
        <div className="qr-hero">
          {heroFailed ? (
            <div className="qr-hero-fallback">게임이냥</div>
          ) : (
            <img
              src={HERO_SRC}
              alt="게임이냥"
              className="qr-hero-img"
              onError={() => setHeroFailed(true)}
              draggable={false}
            />
          )}
        </div>

        <h1 className="qr-title">QR 코드를 스캔하세요</h1>
        <p className="qr-subtitle">휴대폰 카메라로 QR을 스캔해 게임에 참여하세요</p>

        <div className="qr-card">
          {session ? (
            <img
              className="qr-image"
              src={session.qrImageUrl}
              alt="세션 참여 QR 코드"
            />
          ) : (
            <div className="qr-waiting">
              <div className="qr-waiting-dots" aria-hidden="true">
                <span /><span /><span />
              </div>
              <div className="qr-waiting-text">세션을 기다리는 중입니다</div>
            </div>
          )}
        </div>

        {session && <div className="qr-url">{session.qrUrl}</div>}
      </div>
    </div>
  );
}
